import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { NodesService } from '../../+my-libraries/+sites/document-library/shared/services/nodes.service';

@Component({
  selector: 'app-dialog-download-activity',
  templateUrl: './dialog-download-activity.component.html',
  styleUrls: ['./dialog-download-activity.component.scss']
})
export class DialogDownloadActivityComponent implements OnInit {
  public sites: any = [];
  public selectedSite: string;
  public selectedDate: string;
  public siteId: string;
  frenshdates: any[] = [{value: 'month', viewValue: 'Les activités de dernier mois '},
    {value: '6months', viewValue: 'Les activités de  6 derniers mois'},
    {value: '500days', viewValue: 'Les activités de 500 derniers jours'}];


  englishdates: any[] = [{value: 'month', viewValue: 'Last month activities '},
    {value: '6months', viewValue: 'Activities of the last 6 months'},
    {value: '500days', viewValue: 'Activities of the last 500 days'}];

  dates: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogDownloadActivityComponent>,
    public siteService: NodesService,
    private storage: StorageService
  ) {
  }

  ngOnInit() {

    if (localStorage.getItem('lang') === 'fr') {
      this.dates = this.frenshdates;
    } else {
      this.dates = this.englishdates;
    }

    this.siteId = this.data.siteId;
    this.siteService.getSites().then(res => {
      this.sites = res.list.entries;
    });
  }

  public onValidate() {
    let url = '';
    const token = this.storage.getAsync({key: 'token'});
    if (!this.siteId) {
      url = `${window.location.origin}/alfresco/s/synapture/extract-activities?filter=${this.selectedDate}&s=${this.selectedSite}`;
    } else {
      url = `${window.location.origin}/alfresco/s/synapture/extract-activities?filter=${this.selectedDate}&s=${this.siteId}`;
    }

    url += '&attachment=true&alf_ticket=' + token;
    window.open(url, '_blank');

    this.dialogRef.close(true);
  }

  public onCancel() {
    this.dialogRef.close(false);
  }
}
